import style from './VerticalList.module.scss';
import { TextLink } from '@components/TextLink';
import { LinkTarget } from '@components/TextLink/TextLink';

interface ItemProps {
    url: string;
    title: string;
}

export function Item({ url, title }: ItemProps) {
    return (
        <div className={style.item}>
            <TextLink
                target={LinkTarget.SELF}
                link={`/uilab#${url}`}
                label={title}
            />
        </div>
    );
}
